import { AdminPreferences } from "@amzn/ask-legal-domain";
import * as React from "react";
import { useInstanceById } from "../../contexts/InstanceDataContext";
import { SearchInputBar } from "../search/SearchInputBar";
import { PreferenceSelectionModal } from "../instance/PreferenceSelectionModal";
import { AppNavigationHeader } from "../navigation/AppNavigationHeader";
import { AppURLFactory } from "../../factory/app-url-factory";
import "../../styles/component/layout/AppHeader.scss";
const APP_LOGO = require("../../assets/pathfinder-logo-bw-new.png").default;
const AWS_LEGAL_LOGO = require("../../assets/aws-legal-logo-wb.png").default;
const AMAZON_LEGAL_LOGO = require("../../assets/amazon-legal-logo-wb.png").default;

export interface AppHeaderProps {
    instanceId: string;
    headerType?: "Home" | "Content";
}

export const AppHeader = (props: AppHeaderProps) => {
    const { instance, isLoading: loadingInstance } = useInstanceById(props.instanceId);
    const [preferenceSelectionModalProps, setPreferenceSelectionModalProps] =
        React.useState<React.ComponentProps<typeof PreferenceSelectionModal>>();
    const [isMenuOpen, setIsMenuOpen] = React.useState(false);

    // Navigate to new home page when user is on instance homepage, otherwise stay on instance
    const logoHref = AppURLFactory.getHome(
        props.headerType === "Home" ? undefined : props.instanceId
    );

    const getOrganizationLogo = (org: AdminPreferences.Organization) => {
        switch (org) {
            case AdminPreferences.Organization.AMAZON_LEGAL:
                return AMAZON_LEGAL_LOGO;
            case AdminPreferences.Organization.AWS_LEGAL:
            default:
                return AWS_LEGAL_LOGO;
        }
    };

    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

    const handlePreferenceSelection = () => {
        setPreferenceSelectionModalProps({
            onDismiss: () => setPreferenceSelectionModalProps(undefined)
        });
    };

    return <nav className="app-navigation">
        <div className={`nav-container${isMenuOpen ? " active" : ""}`}>
            <div className="nav-left">
                <a href={logoHref}>
                    <img src={APP_LOGO} alt="Pathfinder" className="app-logo" draggable={false} />
                </a>
            </div>

            {instance?.name && <div className={`nav-center${isMenuOpen ? " active" : ""}`}>
                <span
                    className="nav-instance-name-action"
                    title="Click here to access other legal orgs"
                    tabIndex={0}
                    onClick={handlePreferenceSelection}
                >
                    {instance.name}
                </span>
                <AppNavigationHeader instanceId={props.instanceId} isMenuOpen={isMenuOpen} />
            </div>}

            {instance?.preferences?.organization && <div className="nav-right">
                <img
                    src={getOrganizationLogo(instance.preferences.organization)}
                    alt="Org Logo"
                    className="org-logo"
                    draggable={false}
                />
                {props.headerType !== "Home" && <span className="nav-search-bar">
                    <SearchInputBar instanceId={props.instanceId} disabled={loadingInstance} />
                </span>
                }
                {preferenceSelectionModalProps && <PreferenceSelectionModal {...preferenceSelectionModalProps} />}
            </div>}

            <div className="nav-hamburger" onClick={toggleMenu}>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </div>
    </nav>;
};
